import useAvatar from "hooks/avatars/useAvatar";

export const useWorkspaceAvatar = (url?: string, format?: string): string => {
  const FALLBACK_WORKSPACE_LOGO =
    "https://ucarecdn.com/e66c16eb-6594-44bc-b73a-08165bbffbbd/";

  return useAvatar(url || FALLBACK_WORKSPACE_LOGO, format);
};
